/**
 * Timeout for POST …/customer-chat/…/turn (ranked LDS search can exceed 3 minutes).
 * Set VITE_CUSTOMER_CHAT_TURN_TIMEOUT_MS in .env (milliseconds, min 30000).
 */
export function getCustomerChatTurnTimeoutMs() {
  try {
    const raw = String(
      import.meta.env?.VITE_CUSTOMER_CHAT_TURN_TIMEOUT_MS ?? ""
    ).trim();
    const n = parseInt(raw, 10);
    if (Number.isFinite(n) && n >= 30000) return n;
  } catch {
    /* ignore */
  }
  return 600000;
}
